
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/newsArticle/[id]",
      function () {
        return require("private-next-pages/newsArticle/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/newsArticle/[id]"])
      });
    }
  